"use strict";

// module Partial.Unsafe

exports.unsafePartial = function (f) {
  return f();
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-partial/src/Partial/Unsafe.js
// module id = 77
// module chunks = 0